import { Suspense, useState } from "react";
import { PDFDownloadLink, pdf } from "@react-pdf/renderer";
import ViewPdf from "../../pages/ViewPdf";
import { postData } from "../../services/api";
import toastr from "toastr";

const DownloadAction = ({ item }) => {
  const [viewCertificate, setViewCertificate] = useState(false);
  const [sendingEmail, setSendingEmail] = useState(false);

  const handleSendEmail = async () => {
    if (sendingEmail) return;

    if (!window.confirm(`Send certificate email to ${item.email}?`)) {
      return;
    }

    setSendingEmail(true);
    try {
      // Generate PDF using the same ViewPdf component
      const pdfBlob = await pdf(<ViewPdf course={item} />).toBlob();

      // Convert blob to base64
      const reader = new FileReader();
      const pdfBase64 = await new Promise((resolve, reject) => {
        reader.onloadend = () => {
          const base64 = reader.result.split(',')[1];
          resolve(base64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(pdfBlob);
      });

      const res = await postData(`/admin/course/${item.course_id}/user/${item.user_id}/completion-mail/send`, {
        pdfBase64
      });
      if (res.status === 200) {
        toastr.success(res.message || 'Certificate email sent successfully');
      } else {
        toastr.error(res.message || 'Failed to send certificate email');
      }
    } catch (err) {
      console.error('Error sending certificate email:', err);
      toastr.error('Failed to send certificate email');
    }
    setSendingEmail(false);
  };

  // Only show download option for completed courses with a certificate
  if (!item?.certificate_id || item?.completion_status === 'not_started' || item?.completion_status === 'in_progress') {
    return <span className="text-slate-400">-</span>;
  }

  if (!viewCertificate) {
    return (
      <div className="flex items-center gap-3">
        <div className="cursor-pointer" onClick={() => setViewCertificate(true)} title="View certificate">
          <i className="fa-solid fa-eye"></i>
        </div>
        <div
          className={`cursor-pointer ${sendingEmail ? 'opacity-50' : ''}`}
          onClick={handleSendEmail}
          title="Send certificate email"
        >
          {sendingEmail ? (
            <i className="fa-solid fa-spinner fa-spin"></i>
          ) : (
            <i className="fa-solid fa-envelope"></i>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <Suspense fallback={() => <></>}>
        <PDFDownloadLink
          document={<ViewPdf course={item} />}
          fileName='certificate.pdf'
        >
          {({ loading }) =>
            loading ? (
              <i className='fad fa-spinner-third animate-spin'></i>
            ) : (
              <div className='cursor-pointer' title="Download certificate">
                <i className="fa fa-download" aria-hidden="true"></i>
              </div>
            )
          }
        </PDFDownloadLink>
      </Suspense>
      <div
        className={`cursor-pointer ${sendingEmail ? 'opacity-50' : ''}`}
        onClick={handleSendEmail}
        title="Send certificate email"
      >
        {sendingEmail ? (
          <i className="fa-solid fa-spinner fa-spin"></i>
        ) : (
          <i className="fa-solid fa-envelope"></i>
        )}
      </div>
    </div>
  );
};

export default DownloadAction;
